<script>
import { mapMutations } from 'vuex'
import menuMixins from './menuMixins'
import { SET_TABS_MESSAGE_COUNT }  from '../../store/types'

const map = {
    service: '服务API',
}

export default {
    mixins: [menuMixins],
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        tabsMessage() {
            return this.$store.state.modeling.tabsMessageCount
        },
        currentItem() {
            return Object.keys(map).find(key => map[key] === this.data.title)
        },
    },
    methods: {
        ...mapMutations({
            setTabsMessageCount: SET_TABS_MESSAGE_COUNT,
        }),
        clearDot() {
            this.setTabsMessageCount({
                type: this.currentItem,
                count: 0,
            })
        },
    },
    render() {
        const {
            $route,
            data, baseRoute, isTenant,
        } = this
        const {
            title,
            route,
            // icon,
            // activeIcon,
            // activePaths,
            showTenant = true,
        } = data
        const show = isTenant ? showTenant : true
        const index = `${baseRoute}${route}`
        // const isActive = activePaths.map(r => `${baseRoute}${r}`).some(r => {
        //     if (route !== '/object') {
        //         return r === $route.fullPath
        //     }
        //     return $route.fullPath.indexOf(r) !== -1
        // })
        return (
            show
                ? (
                    // <hc-badge is-dot={this.tabsMessage[this.currentItem] > 0} class="badge-style" >
                    <hc-menu-item class={{ 'is-true-active': $route.fullPath.includes(index) }} index={index} onClick={this.clearDot}>
                        <span slot="title">{title}</span>
                    </hc-menu-item>
                    // </hc-badge>
                ) : null
        )
    },
}
</script>

<style lang="less" scoped>
    .badge-style {
        width: 48px;
        /deep/ .hc-badge__content.is-fixed.is-dot {
            right: 9px;
            top: 10px;
        }
    }
</style>
